import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AyudaCmbRequestModel } from '../../models/ayuda/ayuda-cmb-request.model';
import { AyudaEmailRequestModel } from '../../models/ayuda/ayuda-email-request.model';
import { AyudaResponseModel } from '../../models/ayuda/ayuda-response.model';
import { CustomizedHttpService } from '../base/customized-http.service';

@Injectable({
  providedIn: 'root'
})
export class AyudaDataService {
  constructor(private httpService: CustomizedHttpService) {}

  saveCmbRequest(request: AyudaCmbRequestModel): Observable<AyudaResponseModel> {
    return this.httpService.post<any, AyudaResponseModel>('ayuda/saveCmbRequest', request);
  }

  saveEmailRequest(request: AyudaEmailRequestModel): Observable<AyudaResponseModel> {
    return this.httpService.post<any, AyudaResponseModel>('ayuda/saveEmailRequest', request);
  }
}
